var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c2202a;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "footer-mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13,
    cy: 13,
    r: 11.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197,298.37v-1.73c0-.07,0-.15,0-.22.09-.58.14-1.17.26-1.75a13,13,0,0,1,14.48-10,13,13,0,0,1,11,15.32,12.46,12.46,0,0,1-4.75,7.79,12.71,12.71,0,0,1-9.81,2.64,12.35,12.35,0,0,1-5.87-2.38,12.86,12.86,0,0,1-5.17-8.5C197.09,299.12,197,298.75,197,298.37Zm6.36-4.66v9.56h13.07v-9.69l-.19.14c-1.86,1.48-3.72,3-5.58,4.44a1,1,0,0,1-1.44,0L206,295.69Zm12.47-2H204l6,4.61Z",
    transform: "translate(-197 -284.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMail);
export default __webpack_public_path__ + "static/media/ico-mail.7231cf10ca6c7a2690b2a713ee1f36f3.svg";
export { ForwardRef as ReactComponent };